import { SCROLL_ACTIVE_THRESHOLD, SCROLL_THRESHOLD } from 'components/main-nav-bar/constants'
import { UseScrollNavigationProps } from 'components/main-nav-bar/types'
import { useEffect } from 'react'

export const useScrollNavigation = ({
  isMounted,
  isLanguageHeaderVisible,
  isHeaderGroupVisible,
  isMobileMenuOpen,
  setIsScrolled,
  setIsLanguageHeaderVisible,
  setIsHeaderGroupVisible,
  updateHeaderTotalHeight,
}: UseScrollNavigationProps) => {
  useEffect(() => {
    if (!isMounted || typeof window === 'undefined') return

    let lastScrollY = window.scrollY || document.documentElement.scrollTop

    const handleScroll = () => {
      const currentScrollY = window.scrollY || document.documentElement.scrollTop
      setIsScrolled(currentScrollY > SCROLL_ACTIVE_THRESHOLD)

      if (document.body.classList.contains('mobile-nav-active')) {
        if (!isLanguageHeaderVisible) setIsLanguageHeaderVisible(true)
        if (!isHeaderGroupVisible) setIsHeaderGroupVisible(true)
        if (!document.body.classList.contains('--navbar-visible')) {
          document.body.classList.add('--navbar-visible')
        }
        return
      }

      const isScrollingDown = currentScrollY > lastScrollY
      const shouldBeVisible = !isScrollingDown || currentScrollY <= SCROLL_THRESHOLD

      if (shouldBeVisible !== isLanguageHeaderVisible) setIsLanguageHeaderVisible(shouldBeVisible)
      if (shouldBeVisible !== isHeaderGroupVisible) setIsHeaderGroupVisible(shouldBeVisible)

      const bodyClassList = document.body.classList
      const currentlyVisible = bodyClassList.contains('--navbar-visible')
      if (shouldBeVisible && !currentlyVisible) {
        bodyClassList.add('--navbar-visible')
      } else if (!shouldBeVisible && currentlyVisible) {
        bodyClassList.remove('--navbar-visible')
      }

      lastScrollY = Math.max(0, currentScrollY)

      if (updateHeaderTotalHeight) {
        updateHeaderTotalHeight()
      }
    }

    if (
      !document.body.classList.contains('mobile-nav-active') &&
      !document.body.classList.contains('--navbar-visible')
    ) {
      document.body.classList.add('--navbar-visible')
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
      document.body.classList.remove('--navbar-visible', 'mobile-nav-active')
    }
  }, [
    isMounted,
    isLanguageHeaderVisible,
    isHeaderGroupVisible,
    isMobileMenuOpen,
    setIsScrolled,
    setIsLanguageHeaderVisible,
    setIsHeaderGroupVisible,
    updateHeaderTotalHeight,
  ])
}
